import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import type { MemberRyderCupStats } from './ryder-cup-member-stats-container';
import { MemberFilterControls } from './member-filter-controls';
import { StatsTableHeader } from './stats-table-header';
import { MemberStatsRow } from './member-stats-row';
import { StatisticsExplanation } from './statistics-explanation';
import { EmptyStateMessage } from './empty-state-message';
import type { MemberFilter, SortField, SortOrder } from './member-stats-filters.utils';

interface RyderCupMemberStatsProps {
  memberStats: MemberRyderCupStats[];
  memberFilter: MemberFilter;
  onFilterChange: (filter: MemberFilter) => void;
  sortBy: SortField;
  sortOrder: SortOrder;
  onSort: (column: SortField) => void;
}

export default function RyderCupMemberStats({
  memberStats,
  memberFilter,
  onFilterChange,
  sortBy,
  sortOrder,
  onSort,
}: RyderCupMemberStatsProps) {
  return (
    <Container fluid style={{ padding: '20px' }}>
      <Row>
        <Col>
          <h1>Ryd-Her Cup Member Statistics</h1>
          <p className="text-muted">Individual performance statistics from all Ryd-Her Cup team competitions</p>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <MemberFilterControls memberFilter={memberFilter} onFilterChange={onFilterChange} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body style={{ padding: 0 }}>
              <Table striped hover responsive>
                <StatsTableHeader sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                <tbody>
                  {memberStats.map((stat, index) => (
                    <MemberStatsRow key={stat.member.id} stat={stat} index={index} />
                  ))}
                </tbody>
              </Table>

              {memberStats.length === 0 && <EmptyStateMessage memberFilter={memberFilter} />}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <StatisticsExplanation />
        </Col>
      </Row>
    </Container>
  );
}
